module.exports = __webpack_public_path__ + "02_short_black.b6a850b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/02_short_black.png
// module id = NBNf
// module chunks = 0